import { render, staticRenderFns } from "./LkMain.vue?vue&type=template&id=181c3aec&"
import script from "./LkMain.vue?vue&type=script&lang=js&"
export * from "./LkMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports